'use client';
import { createContext, useContext, useEffect, useState } from 'react';
import {
  THEMES,
  defaultTheme,
  normalizeTheme,
  isDarkTheme,
} from '@/constants/themes';

const ThemeContext = createContext();

const applyTheme = (themeId) => {
  const root = document.documentElement;
  THEMES.forEach((t) => root.classList.remove(t.id));
  root.classList.add(themeId);
  root.setAttribute('data-theme', themeId);
  if (isDarkTheme(themeId)) {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
};

export const ThemeProvider = ({ children, initialTheme }) => {
  const normalized = normalizeTheme(initialTheme || localStorage.getItem('theme'));
  const [theme, setThemeState] = useState(normalized);

  useEffect(() => {
    const saved = normalizeTheme(initialTheme || localStorage.getItem('theme') || defaultTheme);
    setThemeState(saved);
    applyTheme(saved);
  }, [initialTheme]);

  // const setTheme = (themeId) => {
  //   const next = normalizeTheme(themeId);
  //   setThemeState(next);
  //   applyTheme(next);
  //   localStorage.setItem('theme', next);
  // };

  // const toggleTheme = () => {
  //   const idx = THEMES.findIndex((t) => t.id === theme);
  //   const next = THEMES[(idx + 1) % THEMES.length];
  //   setTheme(next.id);
  // };

  return (
    <ThemeContext.Provider value={{ theme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
